import { URL } from '@iva/utils';

/**
 * Removes "sznclid" from URL.
 */
export const clearURL = (paramName) =>
  window.history.replaceState(null, document.title, URL.removeParam(window.location.href, paramName));

/**
 * Retrieves parameter value and removes it from URL.
 * @param {String} url URL from which to retrieve sznclid.
 * @param {*} paramName - Name (key) of param to get.
 * @return {String | null} sznclid value or null, if none has been found.
 */
const cutParamFromUrl = (url, paramName) => {
  const queryString = url.includes('?') ? url.split('?')[1] : '';
  const hash = !queryString && url.includes('#') ? url.split('#')[1] : '';

  // queryString includes hash, if no queryString, use hash
  const source = queryString || hash;

  if (!source.includes(paramName)) {
    return null;
  }

  clearURL(paramName);

  const regex = new RegExp(`(?:^|[&#])${paramName}=([^&#]+)`);
  const result = regex.exec(source);

  if (result && result.length > 0) {
    return result[1];
  }
  return null;
};

export { cutParamFromUrl };
